import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Probe } from 'entities/probe'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'
import { ProbeViewModel } from 'view_models/probe_view_model'

export const probeColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'Name', th: true, minWidth: 150, form: form, orderAttr: 'probe_name', searchType: { name: 'name_in', type: 'multiple_text' } },
            { name: 'Status', th: true, width: 150, form: form },
            { name: 'Box', th: true, width: 60, form: form, align: 'center', orderAttr: 'probe_box', searchType: { name: 'box', type: 'text' } },
            { name: '未開封在庫', th: true, width: 100, align: 'center', form: form, orderAttr: 'unopened_probe_stock_count' },
            { name: '開封済在庫', th: true, width: 100, align: 'center', form: form, orderAttr: 'unused_probe_stock_count' },
            { name: '注文中', th: true, width: 80, align: 'center' },
            { name: '最新注文日', th: true, width: 90, align: 'center' },
            {
                name: 'AccessionNumber',
                th: true,
                width: 150,
                form: form,
                orderAttr: 'probe_accession_number',
                searchType: { name: 'accession_number', type: 'text' },
            },
            { name: 'Sequence', th: true, width: 150, form: form, orderAttr: 'probe_sequence', searchType: { name: 'sequence', type: 'text' } },
            { name: 'AssayID', th: true, width: 150, form: form, orderAttr: 'probe_assay_id', searchType: { name: 'assay_id', type: 'text' } },
        ],
    }
}

export type ProbeTableDataProps = {
    probe?: Probe
    displaySetting: DisplaySetting
    onClickStocks?: (probe: Probe) => void
}

export const ProbeTableData = ({ probe, displaySetting, onClickStocks }: ProbeTableDataProps): JSX.Element => {
    if (!probe) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new ProbeViewModel(probe)
        return (
            <>
                <TableCell>{probe.name}</TableCell>
                <TableCell>{vm.statusView()}</TableCell>
                <TableCell align="center">{probe.box}</TableCell>
                <TableCell align="center">
                    {
                        <a
                            style={{ cursor: 'pointer', color: 'blue' }}
                            onClick={() => {
                                if (onClickStocks) {
                                    onClickStocks(probe)
                                }
                            }}
                        >
                            {probe.probeStocks?.filter((ps) => !ps.openedDate).length} 本
                        </a>
                    }
                </TableCell>
                <TableCell align="center">
                    {
                        <a
                            style={{ cursor: 'pointer', color: 'blue' }}
                            onClick={() => {
                                if (onClickStocks) {
                                    onClickStocks(probe)
                                }
                            }}
                        >
                            {probe.probeStocks?.filter((ps) => !!ps.openedDate && !ps.usedDate).length} 本
                        </a>
                    }
                </TableCell>
                <TableCell align="center">
                    <div>{probe.orderingCount} 本</div>
                </TableCell>
                <TableCell align="center">{toDateText(probe.latestOrderDate)}</TableCell>
                <TableCell>{probe.accessionNumber}</TableCell>
                <TableCell>{probe.sequence}</TableCell>
                <TableCell>{probe.assayId}</TableCell>
                <TableCell>{vm.tagsView()}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
